import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { listCategories } from '../api/categories';
import { buildCategoryTree } from '../utils/buildCategoryTree';

const CategoriesContext = createContext(null);

export function CategoriesProvider({ children }) {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    listCategories()
      .then((data) => {
        setCategories(data.categories || []);
      })
      .catch((err) => {
        setError(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const tree = useMemo(() => buildCategoryTree(categories), [categories]);

  const value = useMemo(
    () => ({ categories, tree, loading, error }),
    [categories, tree, loading, error],
  );

  return <CategoriesContext.Provider value={value}>{children}</CategoriesContext.Provider>;
}

export function useCategories() {
  const context = useContext(CategoriesContext);
  if (!context) {
    throw new Error('useCategories must be used within CategoriesProvider');
  }
  return context;
}
